import { LogLevel, setLoggerConfig } from '@silae/helpers/logger';

const enabled = import.meta.env.CE_ENABLE_LOGS;
const logLevel = import.meta.env.CE_LOG_LEVEL;
export function setupLogger() {
	setLoggerConfig({ level: logLevel ?? LogLevel.ERROR, enabled });
}
